// extracted by mini-css-extract-plugin
export default {"pulse_animation":"ChatWidget_pulse_animation__5N6Kw","pulse":"ChatWidget_pulse__oZAqS"};